/**
 * Orders & Checkout Domain API Service
 */

import { api } from './client';
import { Order } from '../../types';

export const orderAPI = {
  // Create new order
  createOrder: async (orderData: any): Promise<Order> => {
    const response = await api.post<Order>('/orders/', orderData);
    return response.data;
  },

  // Get user's order history (requires authentication)
  getOrderHistory: async (): Promise<Order[]> => {
    const response = await api.get<Order[]>('/orders/');
    return response.data;
  },

  // Get order details (requires authentication)
  getOrderDetails: async (orderId: number): Promise<Order> => {
    const response = await api.get<Order>(`/orders/${orderId}/`);
    return response.data;
  },

  // Track order by order number (public)
  trackOrder: async (orderNumber: string): Promise<Order> => {
    const response = await api.get<Order>(`/orders/track/${orderNumber}/`);
    return response.data;
  },

  // PreOrder methods for auto-save and draft recovery
  createPreOrder: async (data: any): Promise<Order> => {
    const response = await api.post<Order>('/orders/preorder/', data);
    return response.data;
  },

  updatePreOrder: async (id: number, data: any): Promise<Order> => {
    const response = await api.patch<Order>(`/orders/${id}/preorder/`, data);
    return response.data;
  },

  confirmPreOrder: async (id: number): Promise<Order> => {
    const response = await api.post<Order>(`/orders/${id}/preorder/confirm/`);
    return response.data;
  },
};
